<template>
  <div class="flex justify-between items-center p-4 shadow-md bg-white">
    <div class="flex gap-4 items-center">
      <!-- Show back arrow on certificate view, otherwise show the two icons -->
      <LeftOutlined
        v-if="isCertificateView"
        class="text-[26px] cursor-pointer hover:text-blue-500 transition-colors"
        @click="onBack"
      />
      <template v-else>
        <MessageOutlined
          class="text-[26px] cursor-pointer hover:text-blue-500 transition-colors"
          @click="onClick(leftIcons[0])"
        />
        <FileTextOutlined
          class="text-[26px] cursor-pointer hover:text-blue-500 transition-colors"
          @click="onClick(leftIcons[1])"
        />
        <!-- 暂时隐藏草稿，下个版本开放 Temporarily hidden -->
        <!-- <FileSearchOutlined
          class="text-3xl cursor-pointer hover:text-blue-500 transition-colors"
          @click="onClick(leftIcons[2])"
        /> -->
      </template>
    </div>

    <div class="text-base sm:text-lg lg:text-xl font-bold text-center flex-1 mx-4 truncate">
      {{ headTitle }}
    </div>

    <div class="flex items-end gap-4">
      <div class="flex items-end gap-2">
        <!-- keep spacing so title remains centered as when the language icon existed -->
        <GlobalOutlined class="text-[26px] opacity-0 pointer-events-none" aria-hidden="true" />
        <a-popover v-model:open="showPopover" placement="bottomRight" trigger="click">
          <template #content>
            <div
              v-for="action in actions"
              :key="action.icon"
              @click="onSelect(action)"
              class="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray-100 transition-colors min-w-[150px]"
            >
              <component :is="getActionIcon(action.icon)" class="text-base flex items-center" />
              <span class="text-base flex items-center">{{ action.text }}</span>
            </div>
          </template>
          <img
            src="@/assets/images/svgs/people.svg"
            class="w-[28px] h-[28px] sm:w-8 sm:h-8 rounded-full cursor-pointer hover:opacity-80 transition-opacity"
          />
        </a-popover>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  MessageOutlined,
  FileTextOutlined,
  //   FileSearchOutlined,
  GlobalOutlined,
  LogoutOutlined,
  UserOutlined,
  WalletOutlined,
  LeftOutlined,
} from "@ant-design/icons-vue";
import { useHeader } from "./useHeader";

const { showPopover, actions, onSelect, leftIcons, headTitle, onClick, isCertificateView, onBack } =
  useHeader();

const getActionIcon = (iconName: string) => {
  if (iconName === "profile") return UserOutlined;
  if (iconName === "logout") return LogoutOutlined;
  if (iconName === "balances") return WalletOutlined;
  if (iconName === "language") return GlobalOutlined;
  return LogoutOutlined;
};
</script>
